// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"a56dec35","787":"95fde3a3"}[chunkId] + ".chunk.js";
};